import { useEffect, useState } from 'react';
import { Utils } from '../../Utils.js';
import { useLocation, useNavigate } from 'react-router-dom';
import { ReactSVG } from "react-svg";
import PageHeader from "../../components/PageHeader/PageHeader.js";

function NavigateBackBtn({children}) {

  const navigate = useNavigate();

  return <div onClick={()=>{navigate(-1)}}>{children}</div>
}

function getDirectBackUrl() {
  var result = '';

  var params = new URLSearchParams(window.location.search);
  var message = params.get("message");

  if (!!window.AppRef.current.state?.others?.message_back_urls) {
    if (typeof window.AppRef.current.state.others.message_back_urls[message] != 'undefined') {
      result = window.location.origin + window.AppRef.current.state.others.message_back_urls[message];
    }
  }

  return result;
}

const Content = (props) => {
  // a server_data-ban van a letöltött adat, ami a setServerSdata függvénnyel frissíthető a state-en belül, ami aztán újra rendelreli a Layout elemet
  const [server_data, setServerSdata] = useState({});

  const location = useLocation();

  // A useEffect egy React Hook, amely lehetővé teszi az összetevők külső rendszerrel való szinkronizálását.
  useEffect(() => {

    const url = location.pathname+((location.search) ? location.search : '');

    Utils.get_server_data(url)
      .then(res => {
        setServerSdata(res);
      });
      
  }, [location]);

  const is_signed = window.AppRef.current.get_is_signed();

  const directBackUrl = getDirectBackUrl();

  return <>
      <div className={`container page_content ${is_signed ? 'signed' : 'unsigned'}`}>
        <div className="content">
          {is_signed ? '' : <PageHeader no_close isHistoryBack />}
          
          <div className='container_inner'>
            <h1 className="page_title">{directBackUrl 
              ? <div><a href={directBackUrl}><ReactSVG className="back" src="assets/images/arrow_down.svg" /></a></div> 
              : <NavigateBackBtn><ReactSVG className="back" src="assets/images/arrow_down.svg" /></NavigateBackBtn>
            }{server_data.title}</h1>
            <div className="page_content" dangerouslySetInnerHTML={{__html: server_data.content}}></div>
          </div>
        </div>
      </div>
    </>;
};

export default Content;